import { AloDataRawHeader, IAloDataRawHeaderConstParam } from "./AloDataRawHeader"

export interface IAloDataRawSetConstParam {
    hasData:boolean
    misId:number|null
    libelle:string
    columns:Array<IAloDataRawHeaderConstParam>
    dataSet: Array<any>
}

export class AloDataRawSet {
    
    public hasData:boolean
    public misId:number|null
    public libelle:string
    public columns:Array<AloDataRawHeader>
    public dataSet:{[index:number]:any}

    constructor({hasData,misId,libelle,columns,dataSet}:IAloDataRawSetConstParam = {} as IAloDataRawSetConstParam) {
        this.hasData = hasData
        this.misId = misId        
        this.libelle = libelle
        this.columns = columns?.map(c => new AloDataRawHeader(c))
        this.dataSet = dataSet?.reduce((datas,data) => {
            datas[data[1]] = data
            return datas
        },{})
    }

    static createAloDataRawSetWithDetail(data:any) {
        return new AloDataRawSet({...data,detailLoaded:true})
    }
}

